<div
  *ngIf="message.type !== 'request_attach' && message.type !== 'balance' && message.type !== 'blur' && message.type !== 'balance_out_coins'"
  [class.message-out]="message.author.is_expert === 'false'"
  [class.message-solution]="message.is_solution === 'true'"
  class="message mb-3"
>
  <!--  AVATAR-->
  <a
    *ngIf="!isNextMessageIsMine(message) && message.author.is_expert === 'true'"
    class="avatar avatar-responsive"
    data-bs-target="#modal-profile"
    data-bs-toggle="modal"
    href="#"
  >
    <img (error)="errorHandler($event)" [src]="message.author.img" alt="" class="avatar-img rounded-2">
  </a>
  <!--  AVATAR END-->
  <!--  MESSAGE-->
  <div [class.message-inner_noavatar]="isNextMessageIsMine(message)" class="message-inner">
    <div class="message-body">
      <div class="message-content">
        <div [class.message-gallery]="isImage(message.file?.name)"
             [class.message-text]="!message.file || isFormula(message)"
             [class.rounded]="isImage(message.file?.name)"
             [ngClass]="(message.reply_id && isImage(message.file?.name)) ? 'p-6' : message.is_blur ? 'p-0' : (!message.file || isFormula(message)) ? 'p-5' : 'p-3'"
        >

          <ng-template [ngIf]="message.is_blur">
            <div class="solution_blurred px-5 py-5">
              <button (click)="billingBtnClick()" class="btn app-btn-yellow btn-outline px-8">
                Show solution
              </button>
            </div>
          </ng-template>
          <ng-template [ngIf]="!message.is_blur">
            <!--  MESSAGE REPLY CONTENT-->
            <ng-template [ngIf]="message.reply_id && getRepliedMsg.id">
              <!--  REPLY TEXT-->
              <blockquote *ngIf="!(getRepliedMsg.file) && getRepliedMsg.type !== 'autosolution'"
                          class="blockquote overflow-hidden">
                <h6 class="text-reset text-truncate">
                  {{getRepliedMsg.author.name}}
                  <span class="reply-date m-0 ms-2 extra-small">
                  ({{(getRepliedMsg.created_at * 1000) | date:'dd.MM.yyyy HH:mm'}})
                </span>
                </h6>
                <p class="small text-truncate">
                  {{getRepliedMsg.body}}
                </p>
              </blockquote>
              <!--  REPLY TEXT END-->

              <!--  REPLY AUTOSOLUTION-->
              <blockquote *ngIf="getRepliedMsg.type === 'autosolution'"
                          class="blockquote overflow-hidden">
                <h6 class="text-reset text-truncate">
                  {{getRepliedMsg.author.name}}
                  <span class="reply-date m-0 ms-2 extra-small">
                  ({{(getRepliedMsg.created_at * 1000) | date:'dd.MM.yyyy HH:mm'}})
                </span>
                </h6>
                <ng-template [ngIf]="getRepliedMsg.data[0].substeps.length">
                  <ng-template
                    [ngForOf]="getRepliedMsg.data[0]?.substeps[0]"
                    let-i="index"
                    let-step
                    ngFor
                  >
                    <div
                      *ngIf="(i + 1) <= (maxAutoSolStepsDisplay - 1)"
                      [class.border-bottom-0]="i === getRepliedMsg.data[0]?.substeps[0].length - 1"
                      [class.mb-5]="i < getRepliedMsg.data[0]?.substeps[0].length - 1"
                      [class.pb-5]="i < getRepliedMsg.data[0]?.substeps[0].length - 1"
                      class="solution__step border-white"
                    >
                      <p
                        *ngIf="step.name.trim()"
                        [innerHTML]="step.name"
                        class="fs-6 text-white"></p>
                      <div
                        *ngIf="step.expression.replaceAll('$', '').trim().length"
                        [innerHTML]="step.expression"
                        class="d-flex formula p-4 rounded justify-content-start"
                      >
                      </div>
                    </div>
                  </ng-template>
                  <p
                    *ngIf="getRepliedMsg.data[0]?.substeps[0].length >= (maxAutoSolStepsDisplay - 1)"
                    class="fs-3"
                  >
                    ...
                  </p>
                  <div>
                    <button
                      (click)="openRepliedAutoSolution(getRepliedMsg)"
                      *ngIf="getRepliedMsg.data[0]?.substeps[0].length >= (maxAutoSolStepsDisplay - 1)"
                      class="btn btn-outline-white w-100"
                      type="button"
                    >
                      Show More
                    </button>
                  </div>
                </ng-template>
              </blockquote>
              <!--  REPLY AUTOSOLUTION END-->

              <!--  REPLY IMAGE-->
              <blockquote *ngIf="getRepliedMsg.file?.name"
                          class="blockquote overflow-hidden">
                <div *ngIf="isImage(getRepliedMsg.file?.name)"
                     class="message-gallery">
                  <div class="d-flex align-items-center">
                    <div
                      class="chat-img__reply d-flex align-items-center justify-content-center rounded overflow-hidden">
                      <img (click)="openLightbox(getRepliedMsg.file.url)"
                           [src]="getRepliedMsg.file.url"
                           alt="" class="h-100"
                           data-action="zoom">
                    </div>
                    <div class="reply-author d-flex flex-column me-auto ms-4">
                      <p
                        [class.fw-bold]="message.type === 'autosolution'"
                        class="reply-name m-0 fs-6"
                      >
                        <ng-template [ngIf]="message.type === 'autosolution'">
                          Solved
                        </ng-template>
                        <ng-template [ngIf]="message.type !== 'autosolution'">
                          {{getRepliedMsg.author.name}}
                        </ng-template>
                      </p>
                      <p class="reply-date text-body m-0 extra-small">
                        {{(getRepliedMsg.created_at * 1000) | date:'dd.MM.yyyy HH:mm'}}
                      </p>
                    </div>
                  </div>
                </div>
              </blockquote>
              <!--  REPLY IMAGE END-->

              <!--  REPLY FORMULA-->
              <blockquote *ngIf="getRepliedMsg.file && !getRepliedMsg.file?.name"
                          class="blockquote overflow-hidden">
                <h6 class="text-reset text-truncate">
                  {{getRepliedMsg.author.name}}
                  <span class="reply-date m-0 ms-2 extra-small">
                  ({{(getRepliedMsg.created_at * 1000) | date:'dd.MM.yyyy HH:mm'}})
                </span>
                </h6>
                <div [innerHTML]="'$' + getRepliedMsg.body + '$'"></div>
              </blockquote>
              <!--  REPLY FORMULA END-->
            </ng-template>
            <!--  MESSAGE REPLY CONTENT END-->

            <!--  IMAGE-->
            <div *ngIf="isImage(message.file?.name)"
                 class="chat-img d-flex align-items-center justify-content-center rounded-1 overflow-hidden border-outline border-1 border-black">
              <img (click)="openLightbox(message.file.url)" [src]="message.file.url" alt="" class="w-100 h-100"
                   style="cursor: pointer">
            </div>
            <!--  IMAGE END-->

            <!--  SIMPLE TEXT OR web_support_message-->
            <p
              *ngIf="!isFormula(message) && message.type !== 'autosolution' && message.type !== 'markdown' && !message.file"
              [innerHTML]="message.body?.replaceAll('\n', '<br>')"
              class="fs-6 m-0 text-break">
            </p>
            <!--  SIMPLE TEXT OR web_support_message END-->

            <!--  AUTO-SOLUTION-->
            <div *ngIf="message.type === 'autosolution'">
              <ng-template [ngIf]="message.data[0].substeps">
                <ng-template [ngIf]="message.data[0].substeps.length">
                  <p
                    *ngIf="message.data[0]?.substeps[0].length >= 2"
                    class="fw-lighter opacity-50 small text-uppercase"
                  >
                    <small>
                      Solving steps
                    </small>
                  </p>
                  <ng-template
                    [ngForOf]="message.data[0]?.substeps[0]"
                    let-i="index"
                    let-step
                    ngFor
                  >
                    <div
                      *ngIf="(i + 1) <= maxAutoSolStepsDisplay"
                      [class.border-bottom-0]="i === message.data[0]?.substeps[0].length - 1"
                      [class.border-ter1]="i === message.data[0]?.substeps[0].length - 1"
                      [class.mb-5]="i < message.data[0]?.substeps[0].length - 1"
                      [class.pb-5]="i < message.data[0]?.substeps[0].length - 1"
                      class="solution__step"
                    >
                      <p
                        *ngIf="step.name.trim()"
                        [innerHTML]="step.name"
                        class="fs-6 text-primblack"></p>
                      <div
                        *ngIf="step.expression.replaceAll('$', '').trim().length"
                        [innerHTML]="step.expression"
                        class="d-flex formula p-4 rounded justify-content-start scroll-container"
                      >
                      </div>
                    </div>
                  </ng-template>
                  <p
                    *ngIf="message.data[0]?.substeps[0].length >= maxAutoSolStepsDisplay"
                    class="text-primblack fs-3"
                  >
                    ...
                  </p>
                  <div>
                    <button
                      (click)="openRepliedAutoSolution(message)"
                      *ngIf="message.data[0]?.substeps[0].length >= maxAutoSolStepsDisplay"
                      class="btn btn-outline-black w-100"
                      type="button"
                    >
                      Show More
                    </button>
                  </div>
                </ng-template>
              </ng-template>

              <!--  TEXT TASK-->
              <ng-template [ngIf]="!message.data[0].substeps">
                <div
                  [innerHTML]="message.body"
                ></div>
              </ng-template>
              <!--  TEXT TASK-->
            </div>
            <!--  AUTO-SOLUTION END-->

            <!--  FORMULA-->
            <div
              *ngIf="isFormula(message)"
              [innerHTML]="'$' + message.body + '$'"
            ></div>
            <!--  FORMULA END-->

            <!--  MARKDOWN-->
            <div
              *ngIf="message.type === 'markdown'"
              [innerHTML]="message.body?.replaceAll('\n', '<br>')"
            ></div>
            <!--  MARKDOWN END-->
          </ng-template>
        </div>
        <div class="message-action">
          <div class="dropdown">
            <a aria-expanded="false"
               class="icon text-muted" data-bs-toggle="dropdown"
               href="#"
               role="button">
              <svg class="feather feather-more-vertical" fill="none" height="24" stroke="currentColor"
                   stroke-linecap="round"
                   stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="12" cy="5" r="1"></circle>
                <circle cx="12" cy="19" r="1"></circle>
              </svg>
            </a>
            <ul aria-labelledby="dLabel" class="dropdown-menu">
              <li>
                <button (click)="replyMessage(message)"
                        class="dropdown-item btn btn-sm app-btn-gray d-flex align-items-center justify-content-between"
                        style="cursor: pointer"
                        type="button">
                  <span>Reply</span>
                  <div class="icon">
                    <svg fill="currentColor" height="12" viewBox="0 0 16 12" width="16"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.41 11.6726C7.17594 11.6726 6.94563 11.6132 6.7325 11.4942C4.73 10.3732 2.61969 8.79606 0.757504 7.40481L0.730942 7.38512C0.270317 7.04043 0.00656692 6.53325 0.00781692 5.99356C0.00906692 5.45606 0.273754 4.95293 0.733754 4.61262C0.881254 4.50356 1.02938 4.39387 1.17782 4.28387C2.99469 2.93793 4.87344 1.54606 6.7325 0.505121C7.18188 0.253871 7.70938 0.268558 8.18063 0.545121C8.76157 0.886058 9.13688 1.5495 9.13657 2.23512V2.99231C9.9875 3.00012 10.8434 3.01668 11.6888 3.04168C11.6919 3.04168 11.6947 3.04168 11.6978 3.042C12.8488 3.09356 13.9328 3.59668 14.75 4.45856C15.5606 5.31387 16.0072 6.41168 16.0069 7.55043V10.1976C16.0069 10.6136 15.7213 10.9673 15.3125 11.0579C14.9328 11.1417 14.5544 10.9573 14.3916 10.6092C13.9069 9.57512 12.8469 8.92668 11.6881 8.95512C10.8441 8.98012 9.98782 8.99668 9.13688 9.0045V9.76543C9.13719 10.4507 8.76219 11.1142 8.18094 11.4551C7.93313 11.6004 7.66969 11.6736 7.41032 11.6736L7.41 11.6726ZM7.41 1.51512C7.35907 1.51512 7.32719 1.53293 7.31219 1.54137C5.51907 2.54512 3.67157 3.91387 1.88469 5.23793C1.73594 5.34825 1.5875 5.45793 1.43969 5.56731C1.2825 5.68356 1.19563 5.83606 1.195 5.99637C1.19469 6.15918 1.28219 6.3145 1.44188 6.43356L1.46844 6.45325C3.30094 7.82262 5.37813 9.37481 7.31219 10.4576C7.34 10.4732 7.42469 10.5204 7.57938 10.4298C7.76313 10.322 7.94907 10.0589 7.94875 9.76481V8.41387C7.94875 8.087 8.21313 7.82168 8.54 7.82012C9.57438 7.81575 10.6225 7.79793 11.6553 7.76731C12.8822 7.73762 14.0331 8.24793 14.8191 9.12575V7.55012C14.8191 6.71668 14.4884 5.90887 13.8878 5.27543C13.2844 4.63887 12.4894 4.26731 11.6488 4.22856C10.6188 4.19825 9.57282 4.18043 8.54 4.17575C8.21313 4.17418 7.94875 3.90887 7.94875 3.582V2.23481C7.94875 1.94043 7.76313 1.67731 7.57938 1.5695C7.50875 1.52793 7.4525 1.51543 7.41 1.51543V1.51512ZM15.4666 10.1045C15.4666 10.1045 15.4672 10.1054 15.4672 10.1061C15.4672 10.1054 15.4666 10.1051 15.4666 10.1045Z"/>
                    </svg>
                  </div>
                </button>
              </li>
              <li *ngIf="isImage(message.file?.name)">
                <a [href]="message.file.url"
                   class="dropdown-item btn btn-sm app-btn-gray d-flex align-items-center just0fy-content-between"
                   style="cursor: pointer"
                   target="_blank">
                  <span class="me-auto">Download</span>
                  <div class="icon">
                    <svg class="feather feather-download" fill="none" height="24" stroke="currentColor"
                         stroke-linecap="round"
                         stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" x2="12" y1="15" y2="3"></line>
                    </svg>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="message-footer">
      <span class="extra-small text-objdis">
        <ng-template [ngIf]="message.author.is_expert === 'false' && message.status === 'read'">
          <svg class="ms-2" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.3179 4.19531C12.0461 3.9349 11.6056 3.9349 11.3342 4.19531L4.86954 10.3906L1.1875 6.86197C0.916098 6.60155 0.475202 6.60155 0.203804 6.86197C-0.0679348 7.12239 -0.0679348 7.54426 0.203804 7.80468L4.3777 11.8047C4.51356 11.9349 4.69155 12 4.86954 12C5.04752 12 5.22551 11.9349 5.36138 11.8047L12.3179 5.13802C12.5896 4.87792 12.5896 4.45573 12.3179 4.19531Z"
              fill="currentColor"/>
            <path
              d="M14.8126 4.19531L7.85615 10.862C7.58441 11.1224 7.58441 11.5443 7.85615 11.8047C7.99201 11.9349 8.17001 12 8.34799 12C8.52598 12 8.70397 11.9349 8.83983 11.8047L15.7963 5.13802C16.0681 4.8776 16.0681 4.45573 15.7963 4.19531C15.5249 3.9349 15.084 3.9349 14.8126 4.19531Z"
              fill="currentColor"/>
          </svg>
        </ng-template>
        <ng-template [ngIf]="message.author.is_expert === 'false' && message.status !== 'read'">
          <svg class="ms-2" fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.3179 4.19531C12.0461 3.9349 11.6056 3.9349 11.3342 4.19531L4.86954 10.3906L1.1875 6.86197C0.916098 6.60155 0.475202 6.60155 0.203804 6.86197C-0.0679348 7.12239 -0.0679348 7.54426 0.203804 7.80468L4.3777 11.8047C4.51356 11.9349 4.69155 12 4.86954 12C5.04752 12 5.22551 11.9349 5.36138 11.8047L12.3179 5.13802C12.5896 4.87792 12.5896 4.45573 12.3179 4.19531Z"
              fill="currentColor"/>
          </svg>
        </ng-template>
        {{(message.created_at * 1000) | date:'dd.MM.yyyy HH:mm'}}
      </span>
    </div>
  </div>
  <!--  MESSAGE END-->
</div>
